import { map } from "lodash";
import { PublicPage, PublicPageCtxFocuse } from "@radarly/models/public-pages";
import { Workspace } from "@radarly/models/workspace";
import { Pagination, WorkspaceRepository } from "./WorkspaceRepository";

function fromPublicPageFocusToWorkspaceFocus(focus: PublicPageCtxFocuse) {
  return {
    id: focus.id,
    offset: 0,
  };
}

function getCurrentWorkspace(publicPage: PublicPage) {
  return {
    ...publicPage.ctx.dashboard,
    focuses: map(publicPage.ctx.focuses, fromPublicPageFocusToWorkspaceFocus),
  } as Workspace;
}
export class PublicWorkspaceRepository implements WorkspaceRepository {
  currentWorkspace: Workspace;
  constructor(publicPage: PublicPage) {
    this.currentWorkspace = getCurrentWorkspace(publicPage);
  }
  public getCurrentWorkspace() {
    return this.currentWorkspace;
  }
  public getProjectWorkspaces(projectId: number): never {
    throw new Error("Implement getProjectWorkspaces");
  }
  public async searchWorkspaces(
    search: string,
    pagination: Pagination
  ): Promise<never> {
    throw new Error("Implement searchWorkspaces");
  }
}
